import React from 'react';
import StockBondReturnsPanel from './StockBondReturnsPanel';
import RateCouponResetPanel from './RateCouponResetPanel';
import InflationRevaluationPanel from './InflationRevaluationPanel';
import YieldCurveSlopePanel from './YieldCurveSlopePanel';
import BtcNasdaqPanel from './BtcNasdaqPanel';
import GoldUsdPanel from './GoldUsdPanel';
import CopperGoldYieldPanel from './CopperGoldYieldPanel';
import OilSp500Panel from './OilSp500Panel';
import './BondInvestingPage.css';

/** @typedef {'overview' | 'stock-bond' | 'btc-nasdaq' | 'gold-usd' | 'commodities'} MacroView */

/**
 * @param {{ view?: MacroView }} props
 */
function BondInvestingPage({ view = 'overview' }) {
  if (view === 'stock-bond') {
    return (
      <div className="bond-investing-page page-content bond-investing-page--single">
        <StockBondReturnsPanel />
      </div>
    );
  }

  if (view === 'btc-nasdaq') {
    return (
      <div className="bond-investing-page page-content bond-investing-page--single">
        <BtcNasdaqPanel />
      </div>
    );
  }

  if (view === 'gold-usd') {
    return (
      <div className="bond-investing-page page-content bond-investing-page--single">
        <GoldUsdPanel />
      </div>
    );
  }

  if (view === 'commodities') {
    return (
      <div className="bond-investing-page page-content bond-investing-page--single">
        <CopperGoldYieldPanel />
        <OilSp500Panel />
      </div>
    );
  }

  return (
    <div className="bond-investing-page page-content">
      <YieldCurveSlopePanel />
      <RateCouponResetPanel />
      <InflationRevaluationPanel />
    </div>
  );
}

export default BondInvestingPage;
